export class Feature {
    ID: number;
    NAME: string;
    DESCRIPTION?: any;
    ACTIVE?: number;
    CREATED_BY?: any;
    CREATED_DATE: Date;
    MODIFIED_BY?: any;
    MODIFIED_DATE?: any;
    FEATURE_HIERARCHIES: any[];
    FEATURE_HIERARCHIES1: any[];
    PRIVILEGE_FEATURES: any[];
}

export function compareFeature(r1: Feature, r2: Feature) {
    const compare = r2.ID - r1.ID;

    if (compare < 0) {
        return 1;
    } else if (compare > 0) {
        return -1;
    } else return 0;
}

export interface RootObjectFeature {
    features: Feature[];
}
